import api from '~/api';
import { NewReferralResponse } from '../dtos/newReferralResponse';

interface NewReferralPayload {
  firstName: string;
  lastName: string;
  companyName: string;
  email?: string;
  mobileNumber?: string;
  note: string;
  partnerId: string;
}

export async function createReferralRequest({
  firstName,
  lastName,
  companyName,
  email,
  mobileNumber,
  note,
  partnerId,
}: NewReferralPayload): Promise<string> {
  const { data } = await api.post<NewReferralResponse>(
    `/v1/partner/${partnerId}/onboarding_accounts`,
    {
      first_name: firstName,
      last_name: lastName,
      business_name: companyName,
      email: email,
      phone_number: mobileNumber,
      note: note,
    }
  );

  return data.id;
}
